<template>
  <div v-hotkey="keymap" v-if="ready">
    <v-list>
      <div class="chat-list" ref="chatList">
        <v-list-item
          :class="{
            'current-user': message.isCurrentUser,
            'not-current-user': !message.isCurrentUser,
          }"
          v-for="(message, index) in messages"
          :key="message.id"
          link
        >
          <v-list-item-content>
            <Message
              :message="message"
              @hook:mounted="messageMounted(index)"
              @messageEvent="messageEventHandler"
            ></Message>
          </v-list-item-content>
        </v-list-item>
      </div>
      <vue-editor
        v-model="newMessage"
        :editorToolbar="customToolbar"
      ></vue-editor>
      <v-list-item link>
        <v-file-input
          show-size
          :rules="rules"
          v-model="file"
          :loading="false"
          label="Додайте файл"
          accept="image/jpeg,
            image/png,
            image/jpg,
            audio/mp3,
            .doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ></v-file-input>
      </v-list-item>
      <v-list-item id="sendItem" link>
        <v-btn
          id="sendButton"
          @click="sendMessage"
          large
          color="primary"
          text
          outlined
          elevation="2"
          >Відправити <i class="material-icons">send</i></v-btn
        >
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import Message from '@/components/View/Chat/Message';
import messageEventEnum from '@/enums/messageEventEnum';
import { VueEditor } from 'vue2-editor';
export default {
  name: 'Chat',
  components: { Message, VueEditor },
  props: {
    fromUser: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    toUser: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
    chatId: [String, Number],
  },
  data() {
    return {
      timeoutId: null,
      newMessage: '',
      file: {},
      rules: [
        (value) => {
          return (
            !value ||
            !value.size ||
            value.size < 5000000 ||
            'Розмір файлу має бути менше 5 MB!'
          );
        },
      ],
      ready: false,
      //https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link'], //'image', 'video'
        ['clean'], // remove formatting button
      ],
    };
  },
  computed: {
    keymap() {
      return {
        enter: this.sendMessage,
      };
    },
    messages() {
      return this.$store.getters['ChatStore/getMessages'];
    },
  },
  watch: {
    async messages() {
      await this.waite(100);
      this.$_setBottom();
    },
  },
  async created() {
    await this.$store.dispatch('ChatStore/initChat', {
      chatId: this.chatId,
      fromUser: this.fromUser,
      toUser: this.toUser,
    });
    await this.$store.dispatch('ChatStore/startActualizeChat');
    this.ready = true;
  },
  async mounted() {
    await this.waiteRenderd();
    this.$_setBottom();
  },
  destroyed() {
    this.$store.dispatch('ChatStore/stopActualizeChat');
  },
  methods: {
    waite(time) {
      return new Promise((resolve) => {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }
        this.timeoutId = setTimeout(resolve, time);
      });
    },
    async waiteRenderd() {
      await this.waite(100);
      const chatList = this.$_getChatList();
      if (chatList) {
        return;
      }
      return this.waiteRenderd();
    },
    updateSubjects() {
      const isTeacherApp = this.$store.getters['ConfigStore/isTeacherApp'];
      if (isTeacherApp) {
        return this.$store.dispatch('TeacherRoomStore/loadTeacherSubjects', {});
      } else {
        return this.$store.dispatch('CourseItemsStore/getItems', {});
      }
    },
    messageEventHandler(payload) {
      const { type, data } = payload;
      switch (type) {
        case messageEventEnum.REMOVE_MESSAGE:
          this.removeMessage(data.id);
          break;
        default:
          console.log(`unsuported type message event type ${type}`);
      }
    },
    async messageMounted(index) {
      if (index !== this.messages.length - 1) {
        return;
      }
      const unreadIds = this.messages.reduce((ids, message) => {
        // if (!message.isRead && !message.isCurrentUser) {
        ids.push(message.id);
        // }
        return ids;
      }, []);

      if (unreadIds.length === 0) {
        return;
      }
      await this.$store.dispatch('ChatStore/markAsRead', {
        ids: unreadIds,
      });
      await this.updateSubjects();
    },
    $_setBottom() {
      const chatList = this.$_getChatList();
      chatList.scrollTop = 100000;
    },
    $_getChatList() {
      return this.$refs.chatList;
    },
    $_validate(file) {
      const isValid =
        file.size &&
        this.rules.every((rule) => {
          return typeof rule(this.file) !== 'string';
        });
      return isValid;
    },
    async sendMessage() {
      const file = this.$_validate(this.file) ? this.file : {};
      this.$store.dispatch('ChatStore/sendMessages', {
        from: {
          text: this.newMessage,
          file,
        },
        to: {},
      });
      this.file = {};
      this.newMessage = '';
      console.log('this.newMessage', this.newMessage);
    },
    removeMessage(messageId) {
      this.$store.dispatch('ChatStore/removeMessageById', {
        messageId,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.current-user {
  background-color: #d3fcfa;
  width: 320px;
  border-radius: 5px;
  margin-left: 50px;
}
.not-current-user {
  background: #ffe3d8;
  width: 320px;
  border-radius: 5px;
}

.not-current-user .v-list-item__content,
.current-user .v-list-item__content {
  // overflow: visible;
}

.v-list-item.v-list-item--link.theme--light.not-current-user {
  margin: 7px;
}
.v-list-item.v-list-item--link.theme--light.current-user {
  margin: 7px;
  margin-left: 167px;
}
.chat-list {
  overflow: auto;
  height: 400px;
  padding: 0;
}
#sendItem {
  width: 183px;
  margin-left: 297px;
}

#sendButton {
  margin-bottom: 10px;
}

.chat-list > v-list-item {
}
::-webkit-scrollbar {
  width: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #228e6e;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.delete-arrow {
  position: relative;
  left: 170px;
}

.author-name {
  font-size: 18px;
  font-weight: bold;
}

.teacher-comment {
  font-style: italic;
  font-size: 19px;
}
</style>
